import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";

export const Creating_Rent_Contract = (pid, bid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newRentContract/${pid}/${bid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATE_CONTRACT_RENT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_List_Rent_Contracts = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRentAgentContract`, config);

      dispatch({
        type: actions.GET_RENT_CONTRACTS,
        payload: {
          doc: res.data.data,
          obj: res.data.data[0].agentId,
          branch_name_rent: res.data.data[0].branchId.name,
        },
      });
    } catch (error) {}
  };
};

export const View_Rent_Contract = (id, index) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRentContract/${id}`, config);

      dispatch({
        type: actions.VIEW_CONTRACT_RENT,
        payload: res.data.data,
        index_rentcontrct: index,
        view_avilable_rent: res.data.data.available_id,
      });
    } catch (error) {}
  };
};

export const Creating_Contract = (pid, bid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newContract/${pid}/${bid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATE_CONTRACT,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Contract Created Error");
    }
  };
};

export const Get_List_Sell_Contracts = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgentContract`, config);
      dispatch({
        type: actions.GET_SELL_CONTRACTS,
        payload: {
          doc: res.data.data,
          obj: res.data.data[0].agentId,
          branch_name: res.data.data[0].branchId.name,
        },
      });
    } catch (error) {}
  };
};

export const View_Sell_Contract = (id, index) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getContract/${id}`, config);

      dispatch({
        type: actions.VIEW_CONTRACT_SELL,
        payload: res.data.data,
        index_sell_contract: index,
        sell_obj_avilabeId: res.data.data.available_id,
      });
    } catch (error) {}
  };
};

///
export const Get_List_Tanents = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getTenantsAgent`, config);
      dispatch({
        type: actions.GET_LIST_OF_TANENTS,
        payload: {
          doc: res.data.data,
          agentId: res.data.data[0].agentId,
          branchId: res.data.data[0].branchId,
        },
      });
    } catch (error) {}
  };
};

export const Creating_Take_Money = (bid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newWasl/${bid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.TAKE_MONEY_CREATING,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Creating_Take_Money Error");
    }
  };
};

export const Get_List_Take_Money = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgentWasls`, config);
      dispatch({
        type: actions.TAKE_MONEY_LIST,
        payload: {
          doc: res.data.data,
          obj: res.data.data[0].branchId,
          name: res.data.data[0].Money_recive,
        },
      });
    } catch (error) {}
  };
};

export const View_Take_Money = (id, index) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getWasl/${id}`, config);
      dispatch({
        type: actions.TAKE_MONEY_VIEW,
        payload: res.data.data,
        index_takemoney: index,
      });
    } catch (error) {}
  };
};

export const Create_Rent_MainForm = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/EXRentContract`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATING_MAIN_RENT_FORM,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Rent Main Form Error");
    }
  };
};

export const Create_Sell_MainForm = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newEXContract`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATING_MAIN_SELL_FORM,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Sell Main Form Error");
    }
  };
};

export const Create_Asayesh = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(`/api/v1/newAsaysh`, { ...data }, config);
      dispatch({
        type: actions.CREATING_MAIN_ASAYSH_FORM,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Main Securty Form Error");
    }
  };
};

export const Get_List_Scurety_Bills = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgentAsayshs`, config);
      dispatch({
        type: actions.GET_SCURETY_BILLS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Bills_Security = (asayshid, index) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAsaysh/${asayshid}`, config);
      dispatch({
        type: actions.VIEW_SCURETY,
        payload: res.data.data,
        index_Scurety: index,
      });
    } catch (error) {}
  };
};

export const Create_Paradan = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newParadan`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATING_MAIN_PARADAN,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Create_Paradan Error");
    }
  };
};

export const Get_List_Paradan = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgentParadans`, config);
      dispatch({
        type: actions.GET_PARADAN_LIST,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Paradan_Bill = (paradanid, index) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getParadan/${paradanid}`, config);
      dispatch({
        type: actions.VIEW_PARADAN,
        payload: res.data.data,
        index_Paradan: index,
      });
    } catch (error) {}
  };
};

/// tenant
export const New_Tenant_Take_Money = (tid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newWaslTenant/${tid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.TAKE_MONEY_TENANTCREATING,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Tenant_View_takeMoney = (tid) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/TenantsWasl/${tid}`, config);
      dispatch({
        type: actions.VIEW_TENANT_TAKYMONEY,
        payload: res.data.data,
        tenant_takemoney_obj: _.head(res.data.data),
      });
    } catch (error) {}
  };
};
export const New_Tenant_Paradan = (tid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newParadan?tid=${tid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.PARADAN_TENANTCREATING,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Tenant_View_Paradan = (tid) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getParadansTenant/${tid}`,
        config
      );

      dispatch({
        type: actions.VIEW_TENANT_PARADAN,
        payload: res.data.data,
        id_tenant_paradan: tid,
        tenant_payment_obj: _.head(res.data.data),
      });
    } catch (error) {}
  };
};

export const Tenant_View_Contract = (tid) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getCOntractRentTenant/${tid}`,
        config
      );

      dispatch({
        type: actions.VIEW_TENANT_CONTRACT,
        payload: res.data.data,
        id_tenant_contract: tid,
      });
    } catch (error) {}
  };
};

export const New_Tenant_Contract = (tid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/EXRentContract?tid=${tid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CONTRACT_TENANTCREATING,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Tenant_Create_Recontract = (pid, bid, tid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/ReRentContract/${pid}/${bid}/${tid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.TENANT_RECONTRACT_CREATING,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Update_SellContract = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/updateContract/${id}`, { ...data }, config);
      dispatch({ type: actions.UPDATE_SELL_CONTRACT });
    } catch (error) {}
  };
};

export const Update_RentContract = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateRentContract/${id}`,
        { ...data },
        config
      );
      dispatch({ type: actions.UPDATE_RENT_CONTRACT });
    } catch (error) {}
  };
};

// update paradan u take money
export const Update_Paradan = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/UpadatParadan/${id}`, { ...data }, config);
      dispatch({ type: actions.UPDATE_PARADAN });
    } catch (error) {}
  };
};
export const Update_TakeMoney = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/updateWasl/${id}`,
        { ...data },
        config
      );
      dispatch({ type: actions.UPDATE_TAKEMONEY, payload: res.data.data });
    } catch (error) {}
  };
};

// Writer Functions
export const Create_Writer_Form = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(`/api/v1/Writing`, { ...data }, config);
      dispatch({
        type: actions.CREATEING_FORM_WRITERS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
// view Writer
export const View_Writer = (id, index) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getWriting/${id}`, config);
      dispatch({
        type: actions.VIEW_WRITORS,
        payload: res.data.data,
        index_write: index,
      });
    } catch (error) {}
  };
};

// get list writors
export const Get_List_Writors = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getWritingsForms`, config);
      dispatch({
        type: actions.GET_WRITERS_LIST,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

// list agents
export const Get_List_Agents = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ListAgents`, config);

      dispatch({
        type: actions.GET_LIST_AGENTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

/// Delete with out note
export const Sell_Delete_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(
        `/api/v1/deleteContract/${id}?status=${status}`,
        config
      );

      dispatch({ type: actions.DELETE_SELL, sell_id: id });
    } catch (error) {}
  };
};

export const Rent_Delete_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(
        `/api/v1/deleteRentContract/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.DELETE_RENT, rent_id: id });
    } catch (error) {}
  };
};

// Delete Parawargrtn
export const TakeMoney_Delete_Status = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/deletWaslWithNote/${id}`,
        { ...data },
        config
      );
      dispatch({ type: actions.DELETE_TAKEMONEY, id: id });
    } catch (error) {}
  };
};

// Delete Paradan
export const Paradan_Delete_Status = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/deletParadanWithNote/${id}`,
        { ...data },
        config
      );
      dispatch({ type: actions.DELETE_PARADAN, id: id });
    } catch (error) {}
  };
};

// Delete Asaysh
export const Scurety_Delete = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteAsaysh/${id}`, { ...data }, config);
      dispatch({ type: actions.SCURETY_DELETE, id: id });
    } catch (error) {}
  };
};

// Update Scurety Bill
export const Update_ScuretyBill = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/updateAsaysh/${id}`, { ...data }, config);
      dispatch({ type: actions.SCURITY_UPDATE });
    } catch (error) {}
  };
};

// Project Actions
export const Apartment_Status = (id, status, hodlerName) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateShuqaSatus/${id}?status=${status}&hodlerName=${hodlerName}`,
        config
      );
      dispatch({ type: actions.STATUS_APARTMENT });
    } catch (error) {}
  };
};

export const Project_Taed = (sid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newProjectSupportShuqa/${sid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATE_TAED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Project_Sellects_Taed = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newProjectSupportArray`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATE_SELECT_TAED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Create_Project_Support = (data) => {
  return async (dispatch) => {
    if (localStorage.token) {
      setToken(localStorage.getItem("token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newProjectSupport`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATING_SUPPORT_PROJECT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_List_Kryar_Bills = () => {
  return async (dispatch) => {
    if (localStorage.token) {
      setToken(localStorage.getItem("token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgentProjectSupports`, config);
      dispatch({
        type: actions.GET_ANKET_BILLS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Bill_Anket_Kryar = (projectsupportID) => {
  return async (dispatch) => {
    if (localStorage.token) {
      setToken(localStorage.getItem("token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getProjectSupport/${projectsupportID}`,
        config
      );
      dispatch({
        type: actions.VIEW_PROJECT_BILLS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_List_Sell_Contracts_Faild = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAgentRejectedContracts`,
        config
      );
      dispatch({
        type: actions.GET_SELL_CONTRACTS_FAILED,
        payload: {
          doc: res.data.data.length !== 0 ? res.data.data : [],
          obj: res.data.data[0].agentId,
          branch_name: res.data.data[0].branchId.name,
        },
      });
    } catch (error) {}
  };
};

export const Get_List_Rent_Contracts_Failed = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAgentRentRejectedContracts`,
        config
      );

      dispatch({
        type: actions.GET_RENT_CONTRACTS_FAILED,
        payload: {
          doc: res.data.data,
          obj: res.data.data[0].agentId,
          branch_name_rent: res.data.data[0].branchId.name,
        },
      });
    } catch (error) {}
  };
};
